export default "__VITE_ASSET__83737314__"